import React from 'react';
import {faPlusSquare} from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './styles.scss';

interface CreateGroupProps {
  onClick: ({}: any) => void;
}

const CreateGroup: React.FC<CreateGroupProps> = ({ onClick }) => {
  return (
    <div className="createGroupContainer" onClick={onClick}>
      <span>Clique para adicionar grupo</span>
      <FontAwesomeIcon icon={faPlusSquare} size={'2x'} />
    </div>
  )
}

export default CreateGroup;
